'use strict';

export default {
  notificationList: {
    organizationInvitationMessage:
      "<b>{invitedBy}</b> vous invite à rejoindre l'organization <b>{organizationName}</b>",
    empty: "Vous n'avez aucune notification pour le moment.",
  },
};
